import * as Yup from "yup";

export const validationSchema = function (questions) {
  const yupObject = {};

  questions.forEach((question) => {
    const key = `questionAnswer_${question.scholarship_application_answers_id}`;
    yupObject[key] = Yup.string()
      .nullable()
      .test({
        name: "notEmpty",
        test(value) {
          if (
            question.question.includes("parent(s)/guardian(s)") ||
            question.question.includes("Family") ||
            question.question.includes("how many dependents") ||
            question.type.includes("Marginalized") ||
            question.question.includes("list the birth year of each dependent")
          ) {
            return true;
          }
          if (
            question.word_limit &&
            question.word_limit > 0 &&
            Object.prototype.toString.call(value) === "[object String]" &&
            value.replace(/<\/?[^>]+(>)/g, " ").match(/\S+/g) != null &&
            value.replace(/<\/?[^>]+(>)/g, " ").match(/\S+/g).length >
              question.word_limit
          ) {
            return this.createError({
              path: key,
              message: "Exceeded word count.",
            });
          }
          if (
            Object.prototype.toString.call(value) === "[object String]" &&
            value.match(/<gdiv[\s\S]*?>|<script[\s\S]*?>/gi)
          ) {
            return this.createError({
              path: key,
              message:
                "It appears that you are using a browser extension such as Ginger. This is unsupported by this application. Please remove the extension, restart your browser, and try again. For support, please contact sfu_uggla_scholars@sfu.ca",
            });
          }
          if (
            Object.prototype.toString.call(value) === "[object String]" &&
            value.length > 0
          ) {
            return true;
          }

          return this.createError({
            path: key,
            message: "Please answer all questions.",
          });
        },
      });
  });

  return Yup.object().shape(yupObject);
};

export const initialValues = function (questions) {
  const initialValuesObj = {};
  questions.forEach((question) => {
    const key = `questionAnswer_${question.scholarship_application_answers_id}`;
    initialValuesObj[key] = "";
  });
  return initialValuesObj;
};
